import { Enumify } from 'enumify';
import ContentRowFormatter from '@root/tabulator/RowFormatters/ContentRowFormatter'
import BetweenRowFormatter from '@root/tabulator/RowFormatters/BetweenRowFormatter'
import BooleanRowFormatter from '@root/tabulator/RowFormatters/BooleanRowFormatter'

class TabulatorRowFormatter extends Enumify {
  static ContentRowFormatter = ContentRowFormatter;
  static BetweenRowFormatter = BetweenRowFormatter;
  static BooleanRowFormatter = BooleanRowFormatter;
  static _ = this.closeEnum();

  lowerEnumKey() {
    return this.enumKey.toLowerCase();
  }
}

export default TabulatorRowFormatter;
